<template>
    <div>
        <div class="grid grid-cols-4 gap-16">
            <div class="col-span-1">
                <ProductFilters :contracts-count="contracts.length" />
            </div>
            <div class="col-span-2">
                <Products
                    v-if="tab === 'allProducts'"
                    :loading="fetchingProducts"
                    :products="products"
                    :selected-items="selectedItems"
                    @more-information="viewChannelInformation"
                />
                <Contracts
                    v-else-if="tab === 'contracts'"
                    :loading="fetchingContracts"
                    :contracts="contracts"
                    :selected-items="selectedItems"
                    @more-information="viewContractInformation"
                />
                <Boosters
                    v-else-if="tab === 'socialChannels'"
                    :loading="fetchingBoosters"
                    :boosters="boosters"
                    :selected-items="selectedItems"
                    @more-information="viewBoosterInformation"
                />
            </div>
            <div class="col-span-1">
                <slot name="basket"></slot>
            </div>

            <popup-modal
                v-if="selectedBooster"
                custom-classes="w-768"
                :text-center="false"
                @close="selectedBooster = null"
            >
                <BoosterDetails :booster="selectedBooster" @added="selectedBooster = null" />
            </popup-modal>

            <popup-modal
                v-if="selectedChannel"
                custom-classes="w-768"
                :text-center="false"
                @close="selectedChannel = null"
            >
                <CampaignDetails :product="selectedChannel" @added="selectedChannel = null" />
            </popup-modal>

            <popup-modal
                v-if="selectedContract"
                custom-classes="w-768"
                :text-center="false"
                @close="selectedContract = null"
            >
                <ContractDetails :contract="selectedContract" @contract-removed="contractRemoved" />
            </popup-modal>
        </div>
    </div>

</template>

<script>
import ProductFilters from "./form/ProductFilters.vue";
import Products from './form/Products.vue';
import Contracts from './form/Contracts.vue';
import Boosters from "./form/Boosters.vue";
import Basket from "./form/Basket.vue";
import BoosterDetails from "./BoosterDetails.vue";
import CampaignDetails from "./CampaignDetails.vue";
import ContractDetails from "./ContractDetails.vue";
import PopupModal from "../ui/PopupModal.vue";
import Booster from "../../models/Booster";
import { mapActions, mapState } from "pinia";
import {useMainStore} from '../../state/store';
import {useMultiPostingStore} from '../../state/modules/multiPosting';

export default {
    name: 'CampaignFormChannels',
    components: {
        Basket, Products, Contracts, Boosters, ProductFilters,
        BoosterDetails, CampaignDetails, ContractDetails, PopupModal
    },
    data() {
        return {
            fetchingContracts: false,
            fetchingBoosters: false,
            selectedBooster: null,
            selectedChannel: null,
            selectedContract: null,
        }
    },
    computed: {
        ...mapState(useMultiPostingStore, ['fetchingProducts', 'fetchingNextProducts', 'filters', 'tab', 'products',
            'contracts', 'boosters', 'selectedItems', 'pagination']),
        ...mapState(useMainStore, ['currentCompany']),
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['fetchProducts', 'fetchContracts', 'fetchBoosters', 'removeSelectedItem',
            'resetPagination', 'setTab', 'removeSelectedItemById']),
        handleScroll(event) {
            const bottomDistance = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
            if (
                bottomDistance < 200
                && this.pagination._pager.next
                && (!this.fetchingProducts && !this.fetchingNextProducts)
                && this.tab === 'allProducts'
            ) {
                this.fetchProducts({ next: true });
            }
        },
        viewBoosterInformation(booster) {
            this.selectedBooster = booster;
        },
        viewChannelInformation(channel) {
            this.selectedChannel = channel;
        },
        viewContractInformation(contract) {
            this.selectedContract = contract;
        },
        contractRemoved(id) {
            this.selectedContract = false;
            this.removeSelectedItemById({itemId: id, ref: "contract_id"});
            this.fetchContracts(true);
            this.$emit('saveProducts', {p: this.selectedItems, inRemoval: true});
        },
        loadContracts(refresh = false) {
            if (!this.contracts.length || refresh) {
                this.fetchingContracts = true;
                this.fetchContracts().then(() => this.fetchingContracts = false);
            }
        },
        loadBoosters(refresh = false) {
            if (!this.boosters.length || refresh) {
                this.fetchingBoosters = true;
                this.fetchBoosters().then(() => this.fetchingBoosters = false);
            }
        },
    },
    watch: {
        tab(newValue) {
            if (this.tab === newValue && !this.products.length) {
                this.fetchProducts({ pagination: this.pagination });
            }
        }
    },
    beforeMount() {
        if (this.tab === 'allProducts' && !this.products.length) {
            this.fetchProducts({ pagination: this.pagination });
        }
    },
    mounted() {
        this.loadContracts();
        this.loadBoosters();
        document.getElementById('content-container').addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        this.resetPagination();
        document
            .getElementById('content-container')
            .removeEventListener('scroll', this.handleScroll);
    },
}
</script>
